import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';
import { Design } from '../designTest/designTest.model';
import { DesignSet } from '../edit-questionset/edit-questionset.model';
import { Schedule } from '../scheduletest/scheduletest.model';
import { Evaluate } from '../evaluate_marks/evaluate.model';
import { Overall_Result } from '../overall_result/overall_result.model';
import { Subject } from 'rxjs/Subject';
import { collectExternalReferences } from '@angular/compiler';

export interface QuestionSet {
  Question_Set_Name: string;
}
export interface College_Names {
  college_name: string;
}
export interface Student_scheduleid {
  user_id: string;
  schedule_id : string;
}
export interface Question_Type_Id{
  question_type_id:string;
}
//score id
export interface scoreid {
  
  userid: string;
  // scoreid:string;
  question_type_id:string;
  question_category_id: string;
  question_sub_category_id: string,
  complexity_id: string;
  correct_ans: string;
  mark: string;
  comments:string;
}
// export interface collegedetails{
//   college_id:string;
//   year_id:string;

// }
//interface for essay question display
export interface student_essay {
  id:string;
  type:string;
}
export interface UserSet {
  userid: string;
  setid: string;
  type_name : string;

}
export interface user_id {
  user_id: string;
  type: any;
}

export interface GenerateSet {
  Question_Set_Id: string;
  Question_Set_Name: string;
}

interface TokenResponse {
  token: string;
}

export interface Pattern {
  pattern: string;
}

export interface UserDetails {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  // confirmpassword: string;
  phone: string;
  type;
  exp: number;
  iat: number;
}

export interface collegeId{
  collegeid:string;
}
export interface collegedetails {
  collegeid: string;
  yearid: string;
  setid:string;
}
export interface testdetails{
  collegeid: string;
  yearid: string;
  setid:string;
  startdate:string;
}

export interface evaluate {
  college_id: string;
  year_id: string;
  questionset_id: string;
}
@Injectable()
export class CollegeService {
  private subject = new Subject<any>();
  private token: string;
  constructor(private http: HttpClient) { }
  private saveToken(token: string): void {
    localStorage.setItem('userToken', token);
    this.token = token;
  }

  private getToken(): string {
    if (!this.token) {
      this.token = localStorage.getItem('userToken');
      //
    }
    return this.token;
  }
  public getUserDetails(): UserDetails {
    const token = this.getToken();
    let payload;
    if (token) {
      //
      payload = token.split('.')[1];
      payload = window.atob(payload);
      return JSON.parse(payload);
    } else {
      return null;
    }
  }

  public isLoggedIn(): boolean {
    const user = this.getUserDetails();
    if (user) {
      return user.exp > Date.now() / 1000;
    } else {
      return false;
    }
  }
  // display questionset:
  public questionset(set: QuestionSet): Observable<any> {
    const base = this.http.post('/users/question_set', set);
    //
    const request = base.pipe(
      map((data: TokenResponse) => {


        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }


  // display College_Name:
  public College_Name(college: College_Names): Observable<any> {
    const base = this.http.post('/users/college', college);
    //
    const request = base.pipe(
      map((data: TokenResponse) => {


        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }

  //shared data
   // Get schedule id for selected user
   public sharedData(student_scheduleid: Student_scheduleid){
    this.subject.next({ text:student_scheduleid });
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }



   // Get schedule id for selected user
   public Student_Schedule_Id(student_scheduleid: Student_scheduleid): Observable<any> {
    const base = this.http.post('/users/student_questionpdf/details', student_scheduleid);
    //
    const request = base.pipe(
      map((data: TokenResponse) => {


        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }

  // Get questions with ans for pdf
  public Questionpdf(student_scheduleid: Student_scheduleid): Observable<any> {
    console.log("student_scheduleid",student_scheduleid)
    const base = this.http.post('/users/student_questionpdf', student_scheduleid);
    //
    const request = base.pipe(
      map((data: TokenResponse) => {


        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }

  // display academicyear:
  public academicyear(college: College_Names): Observable<any> {
    const base = this.http.post('/users/college/academicyear', college);
    //
    const request = base.pipe(
      map((data: TokenResponse) => {


        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }

  // question_set_display
  public question_set_display(set: QuestionSet): Observable<any> {
    const base = this.http.post('/users/question_set_display', set);
    //
    const request = base.pipe(
      map((data: TokenResponse) => {


        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }


  // edit
  public edit(id): Observable<any> {

    var body = {
      id: id
    }
    const base = this.http.post('/users/edit_question_set', body);
    const request = base.pipe(
      map((data: TokenResponse) => {

        //
        if (data.token) {
          this.saveToken(data.token);
        }
        return data;
      })
    );
    return request;
  }

  // update
  public update(set: Array<DesignSet>): Observable<any> {
    //
    // var body = {
    //   id:id
    // }


    const base = this.http.post('/users/update_question_set', set);
    const request = base.pipe(
      map((data: TokenResponse) => {

        //
        if (data.token) {
          this.saveToken(data.token);
        }
        return data;
      })
    );
    return request;
  }


  // delete
  public delete(set: QuestionSet): Observable<any> {

    const base = this.http.post('/users/deleteset', set);

    const request = base.pipe(
      map((data: TokenResponse) => {

        //
        if (data.token) {
          this.saveToken(data.token);
        }
        return data;
      })
    );
    return request;
  }

  //generateSet
  public generateSet(set: Array<DesignSet>): Observable<any> {

    const base = this.http.post('/users/genearateSet', set);

    const request = base.pipe(
      map((data: TokenResponse) => {

        //
        if (data.token) {
          this.saveToken(data.token);
        }
        return data;
      })
    );
    return request;
  }


  // pattern
  public pattern(set: Pattern): Observable<any> {

    var body = {
      id: set
    };
    const base = this.http.post('/users/pattern', body);

    const request = base.pipe(
      map((data: TokenResponse) => {

        //
        if (data.token) {
          this.saveToken(data.token);
        }
        return data;
      })
    );
    return request;
  }

  // schedule

  public schedule(item: Array<Schedule>): Observable<any> {

    const b = this.http.post('/users/schedule', item);
    const request = b.pipe(
      map((data: TokenResponse) => {

        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }

  public update_flags_in_schedule(item: any): Observable<any> {

    const b = this.http.post('/users/schedule/update_flags', item);
    const request = b.pipe(
      map((data: TokenResponse) => {

        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }

  public update_manualEvaluationFlag_in_schedule(item: any): Observable<any> {

    const b = this.http.post('/users/schedule/update_manual_evaluation_flag', item);
    const request = b.pipe(
      map((data: TokenResponse) => {

        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }

  public update_isEvaluated_in_schedule_master(item: any): Observable<any> {

    const b = this.http.post('/users/schedule/update_isEvaluated', item);
    const request = b.pipe(
      map((data: TokenResponse) => {

        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }

  public change_interview_status(item: any): Observable<any> {
    console.log("Printing inside college service ",item);
    let temp ={}
    temp['user_id'] = item

    const b = this.http.post('/users/schedule/interview_shortlist', temp);
    const request = b.pipe(
      map((data: TokenResponse) => {

        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }


  public get_all_student_details(questionSetId:string,collegeId:string,yearId:string): Observable<any> {
    console.log("Inside the get_all_student_details");
    const base = this.http.get(`users/schedule/get_all_student_details?questionSetId=${questionSetId}&collegeId=${collegeId}&yearId=${yearId}`);
    const request = base.pipe(
      map((data : TokenResponse) =>{
        return data;
      })
    );
    return request;
  }


  // scheduledtest_view

  public scheduledtest_view(item: Array<Schedule>): Observable<any> {

    var body = {
      email: item
    };
    const b = this.http.post('/users/scheduledtest_view', body);
    const request = b.pipe(
      map((data: TokenResponse) => {

        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }

  // scheduledtest_viewall
  public scheduledtest_viewall(item: Array<Schedule>): Observable<any> {

    var body = {
      email: item
    };
    const b = this.http.post('/users/scheduledtest_viewall', body);
    const request = b.pipe(
      map((data: TokenResponse) => {

        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }

  // delete_schedule
  public delete_schedule(item: Array<Schedule>): Observable<any> {

    const base = this.http.post('/users/delete_schedule', item);

    const request = base.pipe(
      map((data: TokenResponse) => {

        //
        if (data.token) {
          this.saveToken(data.token);
        }
        return data;
      })
    );
    return request;
  }


  // evaluation_details
  public evaluation_details(item: Array<Evaluate>): Observable<any> {

    // var body = {
    //   email: item
    // };
    const b = this.http.post('/users/evaluation_details', item);
    const request = b.pipe(
      map((data: TokenResponse) => {

        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }

  // evaluate_marks
  public evaluate_marks(item: Array<Evaluate>): Observable<any> {

    // var body = {
    //   email: item
    // };
    const b = this.http.post('/users/evaluate_marks', item);
    const request = b.pipe(
      map((data: TokenResponse) => {

        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }

  // evaluate_all
  // public evaluate_all(item: Array<Evaluate>): Observable<any> {
  //
  //   // var body = {
  //   //   email: item
  //   // };
  //   const b = this.http.post('/users/evaluate_all', item);
  //   const request = b.pipe(
  //     map((data: TokenResponse) => {
  //
  //       // if (data.token) {
  //       //   this.saveToken(data.token);
  //       // }
  //       return data;
  //     })
  //   );
  //   return request;
  //   }

  // overall_result
  public overall_result(item: Array<Overall_Result>): Observable<any> {

    // var body = {
    //   email: item
    // };
    const b = this.http.post('/users/overall_result', item);
    const request = b.pipe(
      map((data: TokenResponse) => {

        return data;
      })
    );
    return request;
  }

  // individual_result
  public individual_result(message:Student_scheduleid ): Observable<any> {

    const b = this.http.post('/users/report/individual_report', message);
    const request = b.pipe(
      map((data: TokenResponse) => {

        return data;
      })
    );
    return request;
  }

  public display_candidate(item: collegedetails): Observable<any> {

    // var body = {
    //   email: item
    // };
    const b = this.http.post('/users/candidate', item);
    const request = b.pipe(
      map((data: TokenResponse) => {

        return data;
      })
    );
    return request;
  }

  //display essay candidates.........
  public display_essay_candidate(item: collegedetails): Observable<any> {

    // var body = {
    //   email: item
    // };
    const b = this.http.post('/users/essay', item);
    const request = b.pipe(
      map((data: TokenResponse) => {

        return data;
      })
    );
    return request;
  }

  public get_Question_type_Name(item: Question_Type_Id): Observable<any>{
    console.log("Inside Karthik");
    const b = this.http.post('/users/essay/question_type_id', item);
    const request = b.pipe(
      map((data: TokenResponse) => {

        return data;
      })
    );
    return request;
  }

  public display_audio_candidate(item: collegedetails): Observable<any> {

    // var body = {
    //   email: item
    // };
    const b = this.http.post('/users/essay/audio', item);
    const request = b.pipe(
      map((data: TokenResponse) => {

        return data;
      })
    );
    return request;
  }

  public display_college_id(): Observable<any> {
    console.log("Inside the display college service");
    const base = this.http.get('users/essay/collegeId');
    const request = base.pipe(
      map((data : TokenResponse) =>{
        return data;
      })
    );
    return request;
  }

  public display_test_date(): Observable<any> {
    console.log("Inside the Date getting service");
    const base = this.http.get('users/essay/startDate');
    const request = base.pipe(
      map((data : TokenResponse ) =>{
        return data;
      })
    );
    return request;
  }

  public get_schedule_details(): Observable<any> {
    console.log("Inside the Schedule details getting service");
    const base = this.http.get('users/essay/scheduleDetails');
    const request = base.pipe(
      map((data : TokenResponse ) =>{
        return data;
      })
    );
    return request;
  }


  // public get_college_name(set: collegeId): Observable<any>{
  //   const base = this.http.get('users/essay/collegeName',set);
  //   const request = base.pipe(
  //     map((data: TokenResponse) =>{
  //       return data;
  //     })
  //   );
  //   return request;
  // }







  //delete candidates.........
  public delete_candidate(item: collegedetails): Observable<any> {

    // var body = {
    //   email: item
    // };
    const b = this.http.post('/users/candidate/delete_candidates', item);
    const request = b.pipe(
      map((data: TokenResponse) => {

        return data;
      })
    );
    return request;
  }

  public display_essay(item: student_essay): Observable<any> {

    const b = this.http.post('/users/display_essays', item);
    const request = b.pipe(
      map((data: TokenResponse) => {

        return data;
      })
    );
    return request;
  }

  //display essay questions.......
  public display_ques(set: UserSet): Observable<any> {


    const b = this.http.post('/users/essay/display_question', set);
    const request = b.pipe(
      map((data: TokenResponse) => {

        return data;
      })
    );
    return request;
  }
  
  public display_audioques(set: UserSet): Observable<any> {


    const b = this.http.post('/users/essay/display_audioquestion', set);
    const request = b.pipe(
      map((data: TokenResponse) => {

        return data;
      })
    );
    return request;
  }
  //save essaymarks.....

  public save_essay_mark(set: scoreid): Observable<any> {


    const b = this.http.post('/users/essay/save_essay_score', set);
    const request = b.pipe(
      map((data: TokenResponse) => {

        return data;
      })
    );
    return request;
  }
  //get score
  public getscore(set: user_id): Observable<any> {


    const b = this.http.post('/users/essay/getscore', set);
    const request = b.pipe(
      map((data: TokenResponse) => {

        return data;
      })
    );
    return request;
  }

  

  public display_audio_answer_res(): Observable<any> {
    console.log("Inside thedisplay_audio_answer_res");
    const base = this.http.get('users/essay/test');
    const request = base.pipe(
      map((data : TokenResponse) =>{
        return data;
      })
    );
    return request;
  }

  public get_Manual_Evaluation_Type_Questions(user_id:any): Observable<any> {
    console.log("Inside thedisplay_audio_answer_res",user_id);
    const base = this.http.get(`users/essay/getManualEvaluationTextQuestions?user_id=${user_id}`);
    const request = base.pipe(
      map((data : TokenResponse) =>{
        return data;
      })
    );
    return request;
  }


  public post_Data_To_DB(item,Test_Taker_User_Id,Schedule_Id): Observable<any> {
    console.log("Printing the Testtaker user id",Test_Taker_User_Id);
    console.log("Printing the Schedule Id",Schedule_Id);
    console.log("Inside the service ......")
    console.log("Printing Item next" ,item);
    var temp = {}
    temp[`Test_Taker_User_Id`] = Test_Taker_User_Id
    temp[`Schedule_Id`] = Schedule_Id
    temp[`scoreDetails`] = item
    console.log("temp",temp)


    const base = this.http.post('/users/evaluate/evaluateNonMcqs',temp);
    //
    const request = base.pipe(
      map((data: TokenResponse) => {


        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }
  public post_eval_status_of_candidate_to_DB(Test_Taker_User_Id): Observable<any> {
    console.log("Printing the Testtaker user id",Test_Taker_User_Id);
   
    console.log("Inside the service of eval status candaidate......")
    
    var temp = {}
    temp[`Test_Taker_User_Id`] = Test_Taker_User_Id
   
    console.log("temp",temp)


    const base = this.http.post('/users/evaluate/changeEvalStatusOfCandidate',temp);
    //
    const request = base.pipe(
      map((data: TokenResponse) => {


        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }

  // public display_scoreid(set:scoreid): Observable<any> {
  //
  //   const b = this.http.post('/users/display_scoreid', set);
  //   const request = b.pipe(
  //     map((data: TokenResponse) => {
  //
  //       return data;
  //     })
  //   );
  //   return request;
  //   }

}



